// The marketing-site header, banner and footer around the check-in and thank-you
// pages. Ported from ottos-consult src/ConsultPage.jsx (PublicHeader,
// ConsultBanner, PublicFooter; the approved Sept 13 look). Text comes from the
// string registry.
import type { ReactNode } from "react";
import { SITE, type ConsultStrings } from "../strings";

export function PublicHeader({ s }: { s: ConsultStrings }) {
  return (
    <header className="oo-public-header">
      <div className="oo-public-header__inner">
        <nav className="oo-public-header__nav" aria-label={s.site.mainNav}>
          <a href={SITE.howItWorks}>{s.site.howItWorks}</a>
          <a href={SITE.industries}>{s.site.industries}</a>
          <a href={SITE.pricing}>{s.site.pricing}</a>
        </nav>
        <a className="oo-public-header__brand" href={SITE.home} aria-label={s.site.homeLabel}>
          <img src="/images/consult/logo-wordmark-blue.png" alt={s.site.brandAlt} />
        </a>
        <div className="oo-public-header__actions">
          <a href={SITE.contact}>{s.site.talkToUs}</a>
          <a className="oo-public-header__muted" href={SITE.clientLogin}>
            {s.site.clientLogin}
          </a>
          <a className="oo-pill-button" href={SITE.home}>
            {s.site.visitSite}
          </a>
        </div>
      </div>
    </header>
  );
}

export function ConsultBanner({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="oo-consult-banner">
      <span>{label}</span>
      <p>{children}</p>
    </div>
  );
}

export function PublicFooter({ s }: { s: ConsultStrings }) {
  return (
    <footer className="oo-public-footer">
      <img src="/images/consult/logo-badge-cream-on-blue.png" alt={s.site.badgeAlt} />
      <p className="oo-public-footer__summary">{s.site.footerSummary}</p>
      <nav className="oo-public-footer__nav" aria-label={s.site.footerNav}>
        <a href={SITE.howItWorks}>{s.site.howItWorks}</a>
        <a href={SITE.industries}>{s.site.industries}</a>
        <a href={SITE.pricing}>{s.site.pricing}</a>
        <a href={SITE.about}>{s.site.about}</a>
        <a href={SITE.contact}>{s.site.talkToUs}</a>
        <a href={SITE.faq}>{s.site.faq}</a>
        <a href={SITE.clientLogin}>{s.site.clientLogin}</a>
      </nav>
      <div className="oo-public-footer__rule" aria-hidden="true">
        <span />
        <img src="/images/consult/starburst-cream.png" alt="" />
        <span />
      </div>
      <p className="oo-public-footer__tagline">{s.site.footerTagline}</p>
      <p className="oo-public-footer__copyright">{s.site.copyright}</p>
    </footer>
  );
}
